(function () {

    angular
        .module('app')
        .controller('CodingLabController', CodingLabController);

    CodingLabController.$inject = [
        'authService', '$state'
    ];

    function CodingLabController(authService, $state) {
        var vm = this;

        vm.energyGuardianDemoUrl = 'static/demos/ai-coding-energy-guardian/index.html';
        vm.requiresLogin = !authService.isAuthenticated();
        vm.openCodingWorkbench = openCodingWorkbench;

        function openCodingWorkbench() {
            if (!authService.isAuthenticated()) {
                return authService.login('coding_workbench', {});
            }
            return $state.go('coding_workbench');
        }
    }
}());
